import { render, staticRenderFns } from "./proInfoDialog.vue?vue&type=template&id=4a666fa4&scoped=true&"
import script from "./proInfoDialog.vue?vue&type=script&lang=js&"
export * from "./proInfoDialog.vue?vue&type=script&lang=js&"
import style0 from "./proInfoDialog.vue?vue&type=style&index=0&id=4a666fa4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a666fa4",
  null
  
)

export default component.exports